import axios from "axios";
import React, {useEffect, useState} from "react";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName} from "../Univ";
function CropVariety() {
    const [rows, setRows] = useState([]);
    const [cropList, setCropList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        crop: "",
        variety_name: "",
        duration_days: "",
        expected_yield: "",
        yield_unit: "Kg/Acre",
        description: ""
    });
    useEffect(() => {
        fetchCrop();
        fetchData();
    }, []);
    const fetchCrop = () => {
        axios.get(baseUrl + "crop/")
            .then((res) => {
                setCropList(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };
    const fetchData = () => {
        setLoading(true);
        axios.get(baseUrl + "crop-variety/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };
    const formSubmit = (e) => {
        e.preventDefault();
        if (!formData.crop) {
            Swal.fire("Error",
                "Select Crop",
                "error");
            return;
        }
        if (!formData.variety_name) {
            Swal.fire("Error",
                "Enter Variety Name",
                "error");
            return;
        }
        const fd = new FormData();
        fd.append("crop",
            formData.crop);
        fd.append("variety_name",
            formData.variety_name);
        fd.append("duration_days",
            formData.duration_days);
        fd.append("expected_yield",
            formData.expected_yield);
        fd.append("yield_unit",
            formData.yield_unit);
        fd.append("description",
            formData.description);
        fd.append("status",
            "1");
        fd.append("addedby",
            userName);
        fd.append("ip_add",
            ipAddress);
        axios.post(baseUrl + "crop-variety/",
            fd)
            .then(() => {
                Swal.fire("Success",
                    "Crop Variety Saved",
                    "success");
                fetchData();
                setFormData({
                    crop: "",
                    variety_name: "",
                    duration_days: "",
                    expected_yield: "",
                    yield_unit: "Kg/Acre",
                    description: ""
                });
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            })
            .catch((err) => {
                console.log(err);
                Swal.fire("Error",
                    "Unable to Save",
                    "error");
            });
    };
    const handleDelete = (id) => {
        Swal.fire({
            title: "Confirm",
            text: "Delete Crop Variety?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete"
        })
            .then((result) => {
                if (result.isConfirmed) {
                    axios.delete(baseUrl +
                        "delete-crop-variety/" +
                        id +
                        "/")
                        .then(() => {
                            Swal.fire("Success",
                                "Deleted Successfully",
                                "success");
                            fetchData();
                        })
                        .catch((err) => {
                            console.log(err);
                            Swal.fire("Error",
                                "Delete Failed",
                                "error");
                        });
                }
            });
    };
    const columns = [
        {
            field: "id",
            headerName: "ID",
            width: 70
        },
        {
            field: "crop",
            headerName: "Crop",
            width: 180,
            renderCell: (params) =>
                params.row.crop?.name || "-"
        },
        {
            field: "variety_name",
            headerName: "Variety",
            flex: 1,
            minWidth: 180
        },
        {
            field: "duration_days",
            headerName: "Duration",
            width: 120,
            renderCell: (params) =>
                params.row.duration_days ?
                    params.row.duration_days + " Days"
                    :
                    "-"
        },
        {
            field: "expected_yield",
            headerName: "Expected Yield",
            width: 150,
            renderCell: (params) =>
                params.row.expected_yield ?
                    params.row.expected_yield +
                    " " +
                    params.row.yield_unit
                    :
                    "-"
        },
        {
            field: "description",
            headerName: "Description",
            flex: 2,
            minWidth: 250
        },
        {
            field: "action",
            headerName: "Action",
            width: 120,
            renderCell: (params) => (
                <button

                    className="btn btn-danger btn-sm"

                    onClick={() =>
                        handleDelete(params.row.id)
                    }

                >

                    Delete

                </button>
            )
        }
    ];
    return (
        <section className="container-fluid mt-4">

            <div className="card shadow">

                <div className="card-header">

                    <h4>

                        Crop Variety Master

                    </h4>

                </div>

                <div className="card-body">

                    <div className="row">

                        <div className="col-md-4">

                            <label>

                                Crop

                            </label>

                            <select

                                className="form-control"

                                name="crop"

                                value={formData.crop}

                                onChange={handleChange}

                            >

                                <option value="">

                                    Select Crop

                                </option>

                                {
                                    cropList.map((item) => (
                                        <option

                                            key={item.id}

                                            value={item.id}

                                        >

                                            {item.name}

                                        </option>
                                    ))
                                }

                            </select>

                        </div>

                        <div className="col-md-4">

                            <label>

                                Variety Name

                            </label>

                            <input

                                type="text"

                                className="form-control"

                                name="variety_name"

                                value={formData.variety_name}

                                onChange={handleChange}

                            />

                        </div>

                        <div className="col-md-4">

                            <label>

                                Duration (Days)

                            </label>

                            <input

                                type="number"

                                className="form-control"

                                name="duration_days"

                                value={formData.duration_days}

                                onChange={handleChange}

                            />

                        </div>

                    </div>

                    <div className="row mt-3">

                        <div className="col-md-4">

                            <label>

                                Expected Yield

                            </label>

                            <input

                                type="number"

                                className="form-control"

                                name="expected_yield"

                                value={formData.expected_yield}

                                onChange={handleChange}

                            />

                        </div>

                        <div className="col-md-4">

                            <label>

                                Yield Unit

                            </label>

                            <input

                                type="text"

                                className="form-control"

                                name="yield_unit"

                                value={formData.yield_unit}

                                onChange={handleChange}

                            />

                        </div>

                        <div className="col-md-4">

                            <label>

                                Description

                            </label>

                            <textarea

                                className="form-control"

                                rows="2"

                                name="description"

                                value={formData.description}

                                onChange={handleChange}

                            />

                        </div>

                    </div>

                    <div className="mt-4">

                        <button

                            className="btn btn-primary"

                            onClick={formSubmit}

                        >

                            Save Variety

                        </button>

                    </div>

                </div>

            </div>
            <div className="mt-4">

                <ERPDataGrid

                    sx={{
                        boxShadow: 4,
                        border: 4,
                        borderColor: "primary.light",
                        "& .MuiDataGrid-cell:hover": {
                            color: "primary.main"
                        }
                    }}

                    rows={rows}

                    columns={columns}

                    loading={loading}

                    autoHeight

                    pageSizeOptions={[10, 25, 50, 100]}


                />

            </div>

        </section>
    );
}
export default CropVariety;